var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChequePaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00016 9.66665C9.92064 9.66665 10.6668 8.92045 10.6668 7.99998C10.6668 7.07951 9.92064 6.33331 9.00016 6.33331C8.07969 6.33331 7.3335 7.07951 7.3335 7.99998C7.3335 8.92045 8.07969 9.66665 9.00016 9.66665Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 6.33331V9.66665",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 12C6.99984 12.5 6.85985 12.9733 6.61318 13.3733C6.15318 14.1466 5.3065 14.6666 4.33317 14.6666C3.35984 14.6666 2.51316 14.1466 2.05316 13.3733C1.80649 12.9733 1.6665 12.5 1.6665 12C1.6665 10.5266 2.85984 9.33331 4.33317 9.33331C5.8065 9.33331 6.99984 10.5266 6.99984 12Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29395 11.9996L3.95394 12.6596L5.37394 11.3463",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3335 10.2V6.00002C2.3335 3.66669 3.66683 2.66669 5.66683 2.66669H12.3335C14.3335 2.66669 15.6668 3.66669 15.6668 6.00002V10C15.6668 12.3334 14.3335 13.3334 12.3335 13.3334H6.66683",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChequePaymentIcon);
export default __webpack_public_path__ + "static/media/cheque-payment-icon .4a063953c3ada02a5064e61394bd8b5b.svg";
export { ForwardRef as ReactComponent };